import { useLocation, useNavigate } from "react-router-dom";
import '../assets/css/style.css';

function BottomNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const hideBottomNav = [
    "/login", "/auth", "/how-to-play", "/refer-earn",
    "/point-system", "/help-support", "/settings",
    "/create-team", "/wallet", "/contests",
    "/verify-account", "/playing-history",
    "/profile", "/choose-captain", "/team-preview"
  ];

  if (hideBottomNav.includes(location.pathname)) return null;

  const navItems = [
    { path: "/home", label: "Home", icon: "house-fill" },
    { path: "/my-contests", label: "My Contest", icon: "trophy-fill" },
    { path: "/account", label: "Account", icon: "person-fill" },
    { path: "/more", label: "More", icon: "three-dots" }
  ];

  return (
    <>
      <div className="bottom-nav-wrapper shadow-lg" 
           style={{ 
               background: "linear-gradient(to right, #6A0000, #800000, #6A0000)", // 🔥 Maroon Theme
               borderTop: "1px solid rgba(255,255,255,0.1)"
           }}>
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;

          return (
            <div
              key={item.path}
              className={`bottom-nav-item ${isActive ? "active-maroon" : "inactive-maroon"}`}
              onClick={() => navigate(item.path)}
            >
              <div className="icon-box">
                <i className={`bi bi-${item.icon}`}></i>
              </div>
              <span className="small fw-bold">{item.label}</span>
            </div>
          );
        })}
      </div>

      {/* 🔥 Custom Styles inside component to override existing style.css for Maroon Theme */}
      <style>{`
        .bottom-nav-wrapper {
            display: flex;
            justify-content: space-around;
            align-items: center;
            position: fixed;
            bottom: 0;
            width: 100%;
            height: 65px;
            z-index: 1000;
        }

        .bottom-nav-item {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            width: 25%;
            transition: all 0.3s ease-in-out;
        }

        /* INACTIVE STATE (Slightly faded white/pink on maroon) */
        .bottom-nav-item.inactive-maroon .icon-box i,
        .bottom-nav-item.inactive-maroon span {
            color: rgba(255, 255, 255, 0.6);
            transition: 0.3s;
        }

        .bottom-nav-item.inactive-maroon .icon-box {
            padding: 5px;
            font-size: 1.2rem;
            margin-bottom: 2px;
        }

        /* ACTIVE STATE (Bright Gold/Yellow on maroon background) */
        .bottom-nav-item.active-maroon .icon-box i {
            color: #800000; /* Icon becomes maroon inside white/gold bubble */
        }
        
        .bottom-nav-item.active-maroon span {
            color: #ffd700; /* Gold text */
            font-size: 0.75rem;
            margin-top: 4px;
        }

        .bottom-nav-item.active-maroon .icon-box {
            background: linear-gradient(135deg, #ffd700, #ffae42); /* Golden Pill */
            padding: 8px 16px;
            border-radius: 20px;
            box-shadow: 0 4px 10px rgba(0,0,0,0.3);
            transform: translateY(-5px);
            font-size: 1.3rem;
        }
      `}</style>
    </>
  );
}

export default BottomNavigation;